import { useCallback, useMemo } from "react";
import { getCheckoutURL } from "../../../routes/bookshelfLinks.ts";
import { useCurrentFullLocale } from "../../utils/locale.ts";
import { useLocation } from "react-router-dom";
import { getBasePathWithoutTrailingSlash } from "../../env.ts";

export default function useCheckoutLinks() {
  const locale = useCurrentFullLocale();
  const location = useLocation();

  const makeCheckoutUrl = useCallback(
    (path = "") => {
      const redirectUrl =
        window.location.origin +
        getBasePathWithoutTrailingSlash() +
        location.pathname +
        location.search;
      return getCheckoutURL(path, {
        locale,
        redirect_url: redirectUrl,
      });
    },
    [locale, location]
  );

  return useMemo(() => ({ makeCheckoutUrl }), [makeCheckoutUrl]);
}
